import { useEffect } from 'react';
import { getRoute, useNavigate } from '../../../../routes';
import { useSurveyContext } from '../contexts/surveyContext';

export const useSurveyRedirect = (): void => {
  const navigate = useNavigate();
  const { hasStarted, hasSignedConsent } = useSurveyContext();

  useEffect(() => {
    // If the survey has not been started, or they have not signed consent, then redirect to the start page.
    // This is to prevent incomplete assessments from being submitted.
    if (!hasSignedConsent || !hasStarted) {
      navigate(getRoute('surveyStart', {}));
    }
  }, [hasStarted, hasSignedConsent]);
};
